export const heroBadges = [
  '6 Volumes',
  '5 Bonuses',
  '200+ Sessions',
  '101 Drills',
  'All Age Groups',
]

export const heroStats = [
  { value: '+500', label: 'COACHES' },
  { value: '6+5', label: 'VOLUMES & BONUSES' },
  { value: '4.9/5', label: 'RATING ⭐' },
  { value: '🌍', label: 'WORLDWIDE' },
]

export const topReviews = [
  {
    quote:
      '"I planned my entire season in a single evening. Now every practice has a clear objective."',
    name: 'Sarah M.',
    location: 'Chicago, USA',
  },
  {
    quote:
      '"My players are improving so much faster now that they finally follow a logical progression."',
    name: 'Coach Emma',
    location: 'Madrid, Spain',
  },
  {
    quote:
      '"I no longer spend hours on YouTube hunting for drills. I open Basketball Ready 360 and it is all there."',
    name: 'Lisa T.',
    location: 'Melbourne, Australia',
  },
]

export const problems = [
  'You arrive at practice without a real plan',
  'You spend hours preparing training before every session',
  'You keep searching for new drills online',
  'Skill levels in your group vary wildly',
  "You don't know how to structure a full season progression",
  'Sessions always feel improvised',
]

export const readyStats = [
  { icon: 'file', value: '300+', label: 'PAGES' },
  { icon: 'dumbbell', value: '200+', label: 'SESSIONS' },
  { icon: 'target', value: '101', label: 'DRILLS' },
  { icon: 'users', value: 'All', label: 'CATEGORIES' },
]

export const coverageTags = [
  'U10-U12',
  'U13-U15',
  'U17-U19/Senior',
  'Physical Conditioning',
  'Tactics',
  'Scouting',
]

export const volumes = [
  {
    dot: '🟢',
    label: 'VOLUME 1',
    title: 'Minibasket U10-U12',
    highlight: '40 complete sessions',
    detail: 'Dribbling · Passing · Footwork · Coordination',
  },
  {
    dot: '🟡',
    label: 'VOLUME 2',
    title: 'Development & Transition U13-U15',
    highlight: '40 complete sessions',
    detail: 'Pick & Roll · Shooting & Defensive Pairs · Transitions',
  },
  {
    dot: '🟠',
    label: 'VOLUME 3',
    title: 'Advanced Tactics U17-U19/Senior',
    highlight: '40 complete sessions',
    detail: 'Advanced Tactics · Defensive Systems · Game Management',
  },
  {
    dot: '🔴',
    label: 'VOLUME 4',
    title: 'Physical Conditioning Protocols',
    highlight: 'Specific training programs',
    detail: 'Speed · Agility · Jump Mechanics · Injury Prevention',
  },
  {
    dot: '🟣',
    label: 'VOLUME 5',
    title: '101 Shooting & Finishing Drills',
    highlight: 'All categories',
    detail: 'Classified by position and level',
  },
  {
    dot: '⭐',
    label: 'VOLUME 6',
    title: 'Scouting & Team Management',
    highlight: 'Advanced coaching tools',
    detail: 'Position-specific evaluations · Performance tracking · Communication',
  },
]

export const volumeIncludes = [
  'Annual Planning',
  'Complete Sessions',
  'Ready-to-use Diagrams',
  'Skill Progressions',
  'Sessions by Age Group',
  'Tracking Tools',
]

export const bonuses = [
  {
    number: 'BONUS 01',
    oldPrice: '$59',
    title: 'Season Planning Calendar',
    description: '12-month visual calendar + weekly planning sheets.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7d1743bb-013a-4a6c-8ea5-7ba91c2e1028.jpg',
    imageAlt: 'Season Planning Calendar book cover',
  },
  {
    number: 'BONUS 02',
    oldPrice: '$64',
    title: '30 Practice Session Templates',
    description: 'Ready-to-use blank session sheets with court diagrams.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/e77c7f68-ada0-4ca0-94e8-a71ecf4da0f5.jpg',
    imageAlt: 'Practice Session Templates book cover',
  },
  {
    number: 'BONUS 03',
    oldPrice: '$79',
    title: 'Tactical Playbook — 30 Set Plays',
    description: 'Complete plays with diagrams — offense, defense and special situations.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/5f48090c-b33e-4082-b14f-bcd2f095d9ad.jpg',
    imageAlt: 'Tactical Playbook book cover',
  },
  {
    number: 'BONUS 04',
    oldPrice: '$64',
    title: 'Player Evaluation Rubrics',
    description: 'Complete assessment toolkit with forms, trackers and parent reports.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/7ce6cbed-fd1a-48d8-ba49-ca5601794f3d.jpg',
    imageAlt: 'Player Evaluation Rubrics book cover',
  },
  {
    number: 'BONUS 05',
    oldPrice: '$72',
    title: 'Warm-Up Bible',
    description: 'Warm-up and cool-down routines for all ages and situations.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/8f853e45-5062-4530-97df-889397eacd95.jpg',
    imageAlt: 'Warm-Up Bible book cover',
  },
]

export const pricingIncludes = [
  '6 Complete Volumes',
  '5 Strategic Bonuses',
  '101 Professional Drills',
  'Over 300 Pages',
  'Lifetime Access',
]

export const playbookFeatures = [
  {
    title: 'Advanced set plays diagrams',
    description: 'Full-court diagrams for the time-out.',
  },
  {
    title: 'Professional movement patterns',
    description: 'Ready-made plays for every game situation.',
  },
  {
    title: 'Game-day cheat sheets',
    description: 'Silent communication with your team.',
  },
  {
    title: 'Video scouting guide',
    description: 'Analyze your opponent from your phone in minutes.',
  },
  {
    title: 'Individual breakdowns',
    description: 'History, metrics and personal goals.',
  },
  {
    title: 'Advanced match reports',
    description: 'Documents ready to hand over.',
  },
]

export const testimonials = [
  {
    initials: 'CS',
    quote:
      '"I mapped out my whole season in one night. Every single practice now has a clear goal, and I walk in knowing exactly what we are doing."',
    name: 'Chloe S.',
    location: 'London, UK',
  },
  {
    initials: 'MR',
    quote:
      '"My team improved faster in two months than in the entire previous season. The progression just makes sense and the kids feel it."',
    name: 'Megan R.',
    location: 'Brisbane, Australia',
  },
  {
    initials: 'SL',
    quote:
      '"I used to spend hours online searching for drills. Now I open Basketball Ready 360 and everything I need is right there."',
    name: 'Sophie L.',
    location: 'Cape Town, SA',
  },
  {
    initials: 'DT',
    quote:
      '"The evaluation rubrics completely changed my conversations with parents. I finally talk in numbers and they trust the process."',
    name: 'David T.',
    location: 'Toronto, Canada',
  },
  {
    initials: 'EW',
    quote:
      '"As a first-year coach I was overwhelmed. This gave me a full system from day one and my confidence on the court doubled."',
    name: 'Emma W.',
    location: 'Manchester, UK',
  },
  {
    initials: 'RB',
    quote:
      '"The Pro Tactical Kit bailed me out in three close games this year. Having those plays ready in a time-out is a game changer."',
    name: 'Rachel B.',
    location: 'Sydney, Australia',
  },
]

export const faqs = [
  {
    question: 'How does Basketball Ready 360 work?',
    answer:
      'You get instant access to all 6 volumes and 5 bonuses in digital format. Download them, open the volume you need and run the session — everything is already planned for you.',
  },
  {
    question: 'Does it work for any age group/category?',
    answer:
      'Yes. The system covers U10-U12, U13-U15 and U17-U19/Senior, with sessions and progressions adapted to every level.',
  },
  {
    question: 'Can I edit the material?',
    answer:
      'The planning sheets and templates are ready to print and use, and the editable planners let you adapt sessions to your own team.',
  },
  {
    question: 'Are the bonuses included?',
    answer:
      'Yes. All 5 strategic bonuses are included at no extra cost with your purchase today.',
  },
  {
    question: 'Is it suitable for beginner coaches?',
    answer:
      'Absolutely. Every session is explained step by step, so you can run professional training even in your first season.',
  },
  {
    question: 'Useful for school PE too?',
    answer:
      'Yes. Hundreds of PE teachers use it for classes and school teams thanks to the ready-to-use sessions and diagrams.',
  },
  {
    question: 'How long does access last?',
    answer:
      'Lifetime access. One single payment, yours forever, including future updates.',
  },
  {
    question: "What's the difference vs other materials?",
    answer:
      'This is a complete system, not a random collection of drills — full season planning, progressions by age group, tactics, physical preparation and team management in one place.',
  },
]

export const comparison = [
  { without: 'Arriving without a real plan', with: '10 min/week. Everything ready.' },
  { without: 'Searching for new drills online', with: '101 drills + 6 volumes by level' },
  { without: 'Skill levels varying wildly', with: 'Logical, measurable progression' },
  { without: 'Sessions feeling improvised', with: 'Evaluation rubrics and progress tracking' },
]
